module.exports = __webpack_public_path__ + "img/ctrl-hadamard-xy-stub-+.e1c74287.svg";